import { Component, OnInit } from "@angular/core";
import { WizardQuestionAnswer, Answer } from "./wizardQuestionAnswer";
import { Router } from "@angular/router";
import { WizardProgressService } from "../services/wizardProgressService";
import { ContactRequestService } from "../services/contactRequestService";

@Component({
    selector: "wizard",
    templateUrl: "wizard.component.html",
    styleUrls:[]
})
export class Wizard implements OnInit {
    constructor(private readonly router: Router, public progressService: WizardProgressService,
        public contactRequestService: ContactRequestService) { }

    private contactType:string;

    ngOnInit() {
        switch (this.router.url) {
        case "/mortgage":
                this.createMortgageWizard();
                this.contactType = "Mortgage Application";
                break;
        case "/remortgage":
                this.createRemortgageWizard();
                this.contactType = "Remortgage Application";
                break;
        case "/book-mortgage-appointment":
            this.createCallBackWizard();
            this.contactType = "Call Back Request";
            break;
        }
        this.progressService.setWizard(this.questions.length);
        this.setCurrentQuestion(1);
    }

    questions: Array<WizardQuestionAnswer>;

    currentQuestion: WizardQuestionAnswer;

    setCurrentQuestion(questionId: number): void {
        if (questionId === -1) {
            const dto = this.contactRequestService.convertWizardQuestionsToContactRequest(this.questions, this.contactType);

            this.progressService.progress = 100;
            this.contactRequestService.postContactRequest(dto);
            this.router.navigate(["/complete"]);
            return;
        }
        this.currentQuestion = this.questions[questionId - 1];
        this.progressService.setQuestion(questionId);
    }

    completeQuestion(answer: string, nextQuestionId: number): void {
        this.currentQuestion.selectedAnswer = answer;
        this.setCurrentQuestion(nextQuestionId);
    }

    // Question Setup
    createRemortgageWizard() {
        this.questions = new Array<WizardQuestionAnswer>();

        const q1 = new WizardQuestionAnswer(1, "Is this a residential or BTL property?", "About the property");
        q1.addAnswer(1, "Residential", 2);
        q1.addAnswer(2, "Buy to Let", 2);
        
        const q2 = new WizardQuestionAnswer(2, "Are you looking for:", "About your current mortgage");
        q2.addAnswer(1, "A better deal", 3);
        q2.addAnswer(2, "To borrow more", 3);
        q2.addAnswer(3, "Something else", 3);

        const q3 = new WizardQuestionAnswer(3, "Please tell us the following:", "About your current mortgage");
        q3.addTextAnswer("How much do you owe on your current mortgage?", "£", "number", false);
        q3.addAnswer(2, "Next", 4);

        const q4 = new WizardQuestionAnswer(4, "Has your current deal come to an end?", "About your current mortgage");
        q4.addAnswer(1, "Yes", 5);
        q4.addAnswer(1, "No", 5);

        const q5 = new WizardQuestionAnswer(5, "Please help us with the following:", "About your current mortgage");
        q5.addTextAnswer("How many remaining years on the term of your mortgage?", "", "text", false);
        q5.addTextAnswer("Who is your current mortgage provider?", "Eg. Barclays, Lloyds, Santandar", "text", false);
        q5.addTextAnswer("What is your current monthly mortgage repayment?", "£", "number", false);
        q5.addAnswer(1, "Next", 6);

        const q6 = new WizardQuestionAnswer(6, "How would you describe your credit history?", "About your credit");
        q6.addAnswer(1, "Excellent", 7);
        q6.addAnswer(2, "Good", 7);
        q6.addAnswer(3, "Poor", 7);
        q6.addAnswer(4, "Very Poor", 7);

        const q7 = new WizardQuestionAnswer(7, "How would you describe your credit history?", "About you");
        q7.addTextAnswer("Full name", "", "text", true);
        q7.addTextAnswer("Telephone number", "", "text", true);
        q7.addTextAnswer("Email address", "", "email", true);
        q7.addTextAnswer("Your age in years", "", "number", true);

        q7.addAnswer(1, "Complete Remortgage Application", -1);

        this.questions.push(q1);
        this.questions.push(q2);
        this.questions.push(q3);
        this.questions.push(q4);
        this.questions.push(q5);
        this.questions.push(q6);
        this.questions.push(q7);
    }

    createMortgageWizard() {
        this.questions = new Array<WizardQuestionAnswer>();

        const q1 = new WizardQuestionAnswer(1, "Have you found the property you wish to buy?", "About the property");
        q1.addAnswer(1, "Yes", 2);
        q1.addAnswer(2, "No", 3);

        const q2 = new WizardQuestionAnswer(2, "What are you plans for the property?", "About your new property");
        q2.addAnswer(1, "To live there", 3);
        q2.addAnswer(2, "To let it out", 3);

        const q3 = new WizardQuestionAnswer(3, "Have you owned a home before?", "About you");
        q3.addAnswer(1, "Yes", 4);
        q3.addAnswer(2, "No", 5);

        const q4 = new WizardQuestionAnswer(4, "What are your plans for this property?", "About your current property");
        q4.addAnswer(1, "To sell it", 5);
        q4.addAnswer(2, "To rent it out", 5);

        const q5 = new WizardQuestionAnswer(5, "Please let us know the following:", "About you");
        q5.addTextAnswer("How much can you put down towards a deposit?", "£", "number", false);
        q5.addTextAnswer("What is the combined income of all applicants", "£", "number", false);
        q5.addAnswer(1, "Next", 6);

        const q6 = new WizardQuestionAnswer(6, "How would you describe your credit history?", "About your credit");
        q6.addAnswer(1, "Excellent", 7);
        q6.addAnswer(2, "Good", 7);
        q6.addAnswer(3, "Poor", 7);
        q6.addAnswer(4, "Very Poor", 7);

        const q7 = new WizardQuestionAnswer(7, "How would you describe your credit history?", "About you");
        q7.addTextAnswer("Full name", "", "text", true);
        q7.addTextAnswer("Telephone number", "", "text", true);
        q7.addTextAnswer("Email address", "", "email", true);
        q7.addTextAnswer("Your age in years", "", "number", true);

        q7.addAnswer(1, "Complete Mortgage Application", -1);

        this.questions.push(q1);
        this.questions.push(q2);
        this.questions.push(q3);
        this.questions.push(q4);
        this.questions.push(q5);
        this.questions.push(q6);
        this.questions.push(q7);
    }

    createCallBackWizard() {
        this.questions = new Array<WizardQuestionAnswer>();

        const q1 = new WizardQuestionAnswer(1, "What time of day is best for one of our Mortgage Librarians to give you a call?", "Book Appointment");
        q1.addAnswer(1, "Now", 3);
        q1.addAnswer(2, "9am to 12pm", 2);
        q1.addAnswer(2, "12pm to 5pm", 2);
        q1.addAnswer(2, "After 5pm", 2);

        const q2 = new WizardQuestionAnswer(2, "What day is best?", "Book Appointment");
        q2.addAnswer(1, "Today", 3);
        q2.addAnswer(2, "Tomorrow", 3);
        q2.addAnswer(2, "Weekday", 3);
        q2.addAnswer(2, "Weekend", 3);

        const q3 = new WizardQuestionAnswer(3, "Please tell us your contact details", "About you");
        q3.addTextAnswer("Full name", "", "text", true);
        q3.addTextAnswer("Telephone number", "", "text", true);
        q3.addTextAnswer("Email address", "", "email", true);
        
        q3.addAnswer(1, "Book Appointment", -1);

        this.questions.push(q1);
        this.questions.push(q2);
        this.questions.push(q3);
    }
}